import { REQUEST, SUCCESS, FAILURE } from '../../actions/auth/verifyMagicLink';

const initialState = {
  isLoading: false,
  data: null,
  error: null,
  token: null,
  user: null
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        token: action.payload.token,
        user: action.payload.user,
        error: null
      };
    case FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        token: null,
        user: null
      };
    default:
      return state;
  }
};
